import { Css, Palette, Tooltip } from "@homebound/beam";
import { formatDate } from "src/components";
import { Maybe } from "src/generated/graphqlTypes";
import { numToStringWithSign } from "src/utils";
import { Temporal } from "temporal-polyfill";

export function ScheduleDateVariance(props: {
  baseline: Maybe<Temporal.PlainDate>;
  current: Maybe<Temporal.PlainDate>;
}) {
  const { baseline, current } = props;
  if (!baseline || !current) return null;
  const variance = current.differenceInBusinessDays(baseline);
  if (variance === 0) return null;
  const color = variance > 4 ? Palette.Red600 : variance > 0 ? Palette.Yellow500 : Palette.Green600;
  return (
    <div data-testid="scheduleDateVariance">
      <Tooltip title={`Baseline: ${formatDate(baseline, "long")}`}>
        <div css={Css.add("color", color).pl1.fw6.$}>{numToStringWithSign(variance)}</div>
      </Tooltip>
    </div>
  );
}
